import React, { useEffect, useState } from "react";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import ToolTip from "./ToolTip";
import { Box } from "@mui/material";
import { toolTipData } from "../utils/tooltipData";
import TypographyPercentageBar from "./TypographyPercentageBar";
import { SocialIcon } from "react-social-icons";
import { Icon } from "./Icon";
import { Link } from "react-router-dom";
import { sentimentRating } from "../utils/sentimentRating";
import { useViewport } from "../viewportListener";
import './slider.css';
import { makeStyles } from '@mui/styles';
import QuestionMarkSvg from './QuestionMarkSvg'
import PriceSentimentDialog from './PriceSentimentDialog'

const useStyles = makeStyles((theme) => ({
  outerDiv: {
    // Add any outer div styles here
  },
  box: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(4),
    border: '1px solid rgba(217, 217, 217, 0.55)',
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1),
  },
  typography1: {
    fontSize: '12px',
    marginLeft: "15px",
    // marginRight:"15px",
    // fontWeight: "500",
    [theme.breakpoints.up('md')]: {
      fontSize: '18px',
      // marginLeft:"22px",
      // marginRight:"22px"
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '20px',
      // marginLeft:"30px",
      // marginRight:"30px"
    },
  },
  // typography2: {
  //   fontWeight: "500",
  //   fontSize: '11px',
  //   [theme.breakpoints.up('md')]: {
  //     fontSize: '16px',
  //   },
  //   [theme.breakpoints.up('lg')]: {
  //     fontSize: '20px',
  //   },
  // },
}));



function SliderComp(props) {
  /* A React Hook that is used to store the state of the component. */
  const postiveArticlesNum = Math.trunc(props?.sentiments?.["positive pct"] * props?.sentiments["total data points"]);
  const negativeArticlesNum = Math.trunc(props?.sentiments?.["negative pct"] * props?.sentiments["total data points"]);
  const postiveArticlesPerc = Math.trunc(props?.sentiments?.["positive pct"] * 100);
  const negativeArticlesPerc = Math.trunc(props?.sentiments?.["negative pct"] * 100);
  const leftSideSliderText = `${postiveArticlesNum} (${postiveArticlesPerc}% of news articles and social media) scraped by Auro bots today recorded Positive Sentiment.`;
  const rightSideSLiderText = `${negativeArticlesNum} (${negativeArticlesPerc}% of news articles and social media) scraped by Auro bots today recorded Negative Sentiment.`;
  // const [mostPositiveCoinToday, positiveChannelCoinToday] = props.sentiments?.["most positive coin channel wise"]?.split(" ");
  // console.log("sss", props);
  // Below code is for check screen-size;
  function isphone() {
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const tabletWidth = 406;

    return viewportWidth >= tabletWidth;
  }
  const [isMobile, setIsMobile] = useState(false);
  const [priceSentimentsChartOpen, setPriceSentimentsChartOpen] = useState(false);
  const [priceSentimentsChartCoin, setPriceSentimentsChartCoin] = useState();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener to handle window resize
    window.addEventListener('resize', handleResize);

    // Initial check for mobile
    setIsMobile(window.innerWidth <= 768);

    // Clean up event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const { width } = useViewport();
  const classes = useStyles();


  const handlePriceChartClose = () => {
    setPriceSentimentsChartOpen(false);
  };

  const handleCoinClick = (coin) => {
    setPriceSentimentsChartCoin(coin.trim().toUpperCase());
    setPriceSentimentsChartOpen(true);
  };

  //End  
  return (
    <>


      <div className="section"
        style={{

        }}
      >
        {priceSentimentsChartOpen && <PriceSentimentDialog open={priceSentimentsChartOpen} handleClose={handlePriceChartClose} coin={priceSentimentsChartCoin} />}
        <div className="sliderDiv" >
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>

            <ToolTip arrow title={leftSideSliderText} placement="top" enterTouchDelay={0}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                <Typography className={classes.typography1} sx={{ color: "#4F9F65", fontWeight: "bold" }}>
                  {postiveArticlesNum}
                </Typography>
                <div style={{ marginLeft: "5px" }}>
                  {
                    isMobile ?
                      (
                        <QuestionMarkSvg />
                      ) : (
                        <div />
                      )}
                </div>
              </div>
            </ToolTip>

            <ToolTip arrow title={rightSideSLiderText} placement="top" enterTouchDelay={0}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                <div style={{ marginRight: "5px" }}>
                  {
                    isMobile ?
                      (
                        <QuestionMarkSvg />
                      ) : (
                        <div />
                      )}
                </div>
                <Typography className={classes.typography1} sx={{ color: "#E56262", fontWeight: "bold" }}>
                  {negativeArticlesNum}
                </Typography>

              </div>
            </ToolTip>
          </div>


          <Slider
            value={props?.sentiments["positive pct"] * 100}
            defaultValue={0.5}
            aria-label="Default"
            sx={{

              color: "#D5B458",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginLeft: "auto",
              marginRight: "auto",
              marginBottom: "5px",
            }}
            disableSwap
          />
        </div>


        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <ToolTip placement="top" arrow title={toolTipData.averagePositiveSentimentsScore} enterTouchDelay={0}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography className={classes.typography1}
                sx={{
                  color: "#4F9F65",
                }}
              >
                Overall+
                {/* {sentimentRating(props.sentiments?.["average positive sentiment"]?.[0]?.toFixed(3))} */}
              </Typography>
              <TypographyPercentageBar value={props.sentiments?.["average positive sentiment"]?.[0]} isMobile={isMobile} />
              <div style={{ marginLeft: "5px" }}>
                {
                  isMobile ?
                    (
                      <QuestionMarkSvg />
                    ) : (
                      <div />
                    )}
              </div>

            </Box>

          </ToolTip>

          <ToolTip placement="top" arrow title={toolTipData.averageNegativeSentimentsScore} enterTouchDelay={0}>
            <Box sx={{ display: "flex", alignItems: "center" }}>

              <div style={{ marginRight: "5px" }}>
                {
                  isMobile ?
                    (
                      <QuestionMarkSvg />
                    ) : (
                      <div />
                    )}
              </div>
              <TypographyPercentageBar
                value={props.sentiments?.["average negative sentiment"]?.[0]} positive={false} style={{ right: 0, marginRight: "10px" }} isMobile={isMobile}
              />
              <Typography className={classes.typography1}
                sx={{
                  color: "#E56262",
                }}
              > Overall-
                {/* {sentimentRating(props.sentiments?.["average negative sentiment"]?.[0]?.toFixed(3))} */}
              </Typography>
            </Box>
          </ToolTip></div>
      </div>









      <div className="section"
        style={{

        }}
      >


        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <ToolTip placement="top" arrow title={toolTipData.mostPositiveBullishCoinChannel} enterTouchDelay={0}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography className={classes.typography1}
                sx={{ color: "#4F9F65" }}>
                Top+
              </Typography>

              <TypographyPercentageBar value={props.sentiments?.["most positive coin sentiment"]?.[0]} isMobile={isMobile} />
              <div style={{ marginLeft: "5px" }}>
                {
                  isMobile ?
                    (
                      <QuestionMarkSvg />
                    ) : (
                      <div />
                    )}
              </div>
            </Box>
          </ToolTip>
          <ToolTip placement="top" arrow title={toolTipData.mostNegativeBearishCoinChannel} enterTouchDelay={0}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginRight: "5px" }}>
                {
                  isMobile ?
                    (
                      <QuestionMarkSvg />
                    ) : (
                      <div />
                    )}
              </div>
              <TypographyPercentageBar positive={false} value={props.sentiments?.["most negative coin sentiment"]?.[0]} style={{ right: 0, marginRight: "10px" }} isMobile={isMobile} />
              <Typography className={classes.typography1}
                sx={{ color: "#E56262" }}>
                Top-
              </Typography>
            </Box>
          </ToolTip>
        </div>


        <div style={{
          display: "flex",
          justifyContent: "space-between",
        }}>
          <Box display="flex" gap={2} alignItems="start" marginTop={isMobile ? "10px" : "15px"}>
            {/* <ToolTip placement="top" arrow title={toolTipData.mostBullishCoinPair}> */}
            <Box display="flex" gap={1} alignItems="center" justifyContent="end">
              <ToolTip placement="top" arrow title={`${props.sentiments?.["most positive coin channel wise"]?.split(" ")?.[0] + " " + toolTipData.mostBullishCoinPair}`} enterTouchDelay={0}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <Typography 
                  onClick={()=>{handleCoinClick(props.sentiments?.["most positive coin channel wise"]?.split(" ")?.[0])}}
                    sx={{ 
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    {props.sentiments?.["most positive coin channel wise"]?.split(" ")?.[0]}
                  </Typography>
                  <Icon name={props.sentiments?.["most positive coin channel wise"]?.split(" ")?.[0]} url={props.iconURLs.positiveURL} />
                  {/* <Icon name={props.sentiments?.["most positive coin channel wise"]?.split(" ")?.[0]} url="https://s2.coinmarketcap.com/static/img/coins/64x64/1.png" /> */}

                </Box>

              </ToolTip>
              -
              <ToolTip placement="top" arrow title={`${props.sentiments?.["most positive coin channel wise"]?.split(" ")?.[1] + " " + toolTipData.positiveArticlesByAuroDigital}`} enterTouchDelay={0}>
                <Box>
                  <SocialIcon
                    network={props.sentiments?.["most positive coin channel wise"]?.split(" ")?.[1].toLowerCase()}
                    style={{
                      fontSize: "10px",
                      backgroundColor: "white",
                      width: isMobile ? "24px" : "30px",
                      height: isMobile ? "24px" : "30px",

                    }}
                  />
                </Box>
              </ToolTip>
            </Box>
            {/* </ToolTip> */}

          </Box>



          <Box display="flex" gap={20} alignItems="center" marginTop={isMobile ? "10px" : "15px"} marginLeft={isMobile ? "-10px" : "auto"}>
            <Box display="flex" gap={1} alignItems="center">
              <ToolTip placement="top" arrow title={`${props.sentiments?.["most negative coin channel wise"]?.split(" ")?.[0] + " " + toolTipData.mostBearishCoinPair}`} enterTouchDelay={0}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <Typography 
                  onClick={()=>{handleCoinClick(props.sentiments?.["most negative coin channel wise"]?.split(" ")?.[0])}}
                  
                    sx={{
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    {props.sentiments?.["most negative coin channel wise"]?.split(" ")?.[0]}
                  </Typography>
                  <Icon name={props.sentiments?.["most negative coin channel wise"]?.split(" ")?.[0]?.toLowerCase()} url={props.iconURLs.negativeURL} />
                  {/* <Icon name={props.sentiments?.["most positive coin channel wise"]?.split(" ")?.[0]} url="https://s2.coinmarketcap.com/static/img/coins/64x64/1.png" /> */}
                </Box>
              </ToolTip>
              -
              <ToolTip placement="top" arrow title={`${props.sentiments?.["most negative coin channel wise"]?.split(" ")?.[1] + " " + toolTipData.negativeArticlesByAuroDigital}`} enterTouchDelay={0}>
                <Box>
                  <SocialIcon
                    network={props.sentiments?.["most negative coin channel wise"]?.split(" ")?.[1]?.toLowerCase()}
                    style={{
                      fontSize: "10px",
                      backgroundColor: "white",
                      width: isMobile ? "24px" : "30px",
                      height: isMobile ? "24px" : "30px",
                    }}
                  />
                </Box>
              </ToolTip>
            </Box>

          </Box>
        </div>
      </div>

      {/* coin tabele link */}

      <div className="section"
        style={{
          display: "flex",
          justifyContent: "space-between"
        }}
      >

        <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
          <Typography className={classes.typography1}
            sx={{
              color: "#4F9F65",
            }}
          >
            Top 10+
          </Typography>
          {/* <Link to="/coinTable/top/10"> */}
          <Box
            onClick={() => {
              props.handleTable("top");
            }}
            sx={{
              cursor: "pointer",
            }}
          >
            <img src={"./assets/up.svg"} alt="marketUp" />
          </Box>
        </Box>



        <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
          {/* <Link to="/coinTable/bottom/10"> */}
          <Box
            onClick={() => {
              props.handleTable("bottom");
            }}
            sx={{
              cursor: "pointer",
            }}
          >
            <img src={"./assets/down.svg"} alt="marketDown" />
          </Box>

          <Typography className={classes.typography1}
            sx={{
              color: "#E56262",
            }}
          > Top 10-

          </Typography>
        </Box>

      </div>
    </>
  );
}

export default SliderComp;
